import { useEffect, useState } from 'react';
import useBreakpoint from './useBreakpoint';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from './components/IconButton';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomTableRow from './components/CustomTableRow';
import { jwtDecode } from "jwt-decode";
import { Button, Modal } from 'react-bootstrap';

export const replaceUnderscoreAndCamelCaseToString = (str) => {
    return str
      .replace(/([A-Z])/g, " $1")
      .replace(/([A-Z])/g, " $1")
      .replaceAll("_", " ")
      .toUpperCase();
  };

const MyEvaluations = () => {
  const [size] = useBreakpoint();
  const [evaluationsList, setEvaluationsList] = useState([]);
  const [evaluationsListOLA, setEvaluationsListOLA] = useState([]);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [submissionIdToDelete, setSubmissionIdToDelete] = useState("");
  const [evaluationIdToDelete, setEvaluationIdToDelete] = useState("");
  const navigate = useNavigate();
  const location = useLocation();



    useEffect(() => {

        fetchEvaluations();

        axios.get("http://ascola-dev01.it.auth.gr/api/ola-courses", {
                params: {
                    email: "saouling@it.auth.gr"
                }, headers: { Authorization: "Bearer " + localStorage.getItem('access_token')} })
            .then((response) => {
            console.log(response); setEvaluationsListOLA(response?.data);
            });
    }, []);

    useEffect(() => {
        if (evaluationsList?.length > 0 && evaluationsListOLA?.length > 0) {
            let evaluationsOLATemp = [];
            evaluationsOLATemp = evaluationsListOLA.filter(function(val) {
                return evaluationsList.map(elem => elem.evaluation_submission.la_id).indexOf(val.la_id) === -1;
            });
            setEvaluationsListOLA(evaluationsOLATemp);
        }
    }, [evaluationsList]);

    

    const handleDelete = () => {
        axios.delete("http://ascola-dev01.it.auth.gr/api/evaluations/" + evaluationIdToDelete + "/" + submissionIdToDelete,{ headers: { Authorization: "Bearer " + localStorage.getItem('access_token')}})
          .then((response) => {
            console.log(response); fetchEvaluations(); setShowModalDelete(false); alert("Successfully Deleted!"); setSubmissionIdToDelete(""); setEvaluationIdToDelete("");
          });
          setSubmissionIdToDelete(""); setEvaluationIdToDelete("");
    };

    const fetchEvaluations = () => {

        const token = localStorage.getItem('access_token');

        axios.get("http://ascola-dev01.it.auth.gr/api/evaluations", {
            params: {
                email: tokenEmail(token)
            }, headers: { Authorization: "Bearer " + localStorage.getItem('access_token')} })
        .then((response) => {
            console.log(response); setEvaluationsList(response?.data);
        });
    };

    const tokenEmail = (token) => {
        if (!token) return true;
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken.email;
        } catch (error) {
            console.error('Error decoding token:', error);
            return true;
        }
    };


  return (<>
    {(size !== "xs" && size !== "sm" && size !== "md") && (
    <> <div className="all-evaluations-main-container rounded-3 mx-auto d-flex flex-column align-items-center position-relative" >
        <div className="title mb-4">
            <h1 className="register-text" style={{fontSize: 40, marginBottom: 25, marginTop: 70}}>My evaluations</h1>
            <div style={{marginBottom: 40, fontSize: 16, textAlign: "left", marginTop: 10, lineHeight: "30px"}}>Here you can find the list of courses of the Online Learning Agreement you took in exchange.
            Provide feedback by  clicking on<br/> the ‘Create new evaluation’ button in the last column. You can also edit or delete previously submitted evaluations, by clicking<br/> on the ‘Edit’ icon <IconButton style={{marginLeft: 5}}
                        variant="edit"/> or ‘Delete’ icon<IconButton style={{marginLeft: 5}}
                        variant="delete"/>.

If you are academic staff of an HEI or future  exchange student looking for more <br/>info about the courses, please visit <a href={window.location.origin + "/all-evaluations"} style={{color: "burlywood"}}>‘All Evaluations’</a>.

            </div>
        <TableContainer component={Paper}>
        <Table aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell>COURSE TITLE</TableCell>
                <TableCell style={{width: 180}} align="right">COURSE CODE</TableCell>
                <TableCell align="right">ACADEMIC TERM</TableCell>
                <TableCell align="right">ECTS</TableCell>
                <TableCell align="right"></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {evaluationsListOLA?.map((row) => (
                    <TableRow
                        key={row.name}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            {row?.course_title}
                        </TableCell>
                        <TableCell align="right">{row?.course_code}</TableCell>
                        <TableCell align="right">{row?.academic_term}</TableCell>
                        <TableCell align="right">{row?.ects}</TableCell>
                        <TableCell align="right">
                            <div
            // key={iia?.id}
                                className={`py-3 px-2 justify-content-end justify-content-lg-around align-items-center bg-none bg-md-light button-triplet-requests flex-grow-1 d-flex gap-3 gap-lg-1`}
                            >
                                <IconButton
                                variant="add"
                                onClick={() => navigate("/new-evaluation", {
                                    state: {
                                      rowOLA: row,
                                    }}) }
                                //   disabled={(iia?.terminated && iia?.iia_status !== "approved-by-all")}
                                //   title={(iia?.iia_status === "approved-by-all") ? "Modify IIA" : "Edit IIA"}
                                //   onClick={(e) => {
                                //     navigate("/iias/edit/" + iia?.id);
                                //   }}
                                /><span style={{textAlign: "left"}}>Create new evaluation</span>

                                {/* <IconButton
                                variant="delete"
                                title="Delete IIA"
                                //   disabled={(iia?.approved_copy) || iia?.iia_status === "approved-by-all"}
                                //   onClick={() => {
                                //     setShowModalDelete(true); setIdToDelete(iia?.id);}}   
                                /> */}
                            </div>
                            </TableCell>
                            </TableRow>
                    )
                
                
                
            )}
            {evaluationsList?.map((row) => (
                <TableRow
                key={row.name}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                <TableCell component="th" scope="row">
                    {row?.course?.course_title}
                </TableCell>
                <TableCell align="right">{row?.course?.course_code}</TableCell>
                <TableCell align="right">{row?.course?.academic_term}</TableCell>
                <TableCell align="right">{row?.course?.ects}</TableCell>
                <TableCell align="right">
                    <div
                // key={iia?.id}
                        className={`py-3 px-2 justify-content-end justify-content-lg-around align-items-center bg-none bg-md-light button-triplet-requests flex-grow-1 d-flex gap-3 gap-lg-1`}
                    >
                        <IconButton
                        variant="edit"
                        //   disabled={(iia?.terminated && iia?.iia_status !== "approved-by-all")}
                        //   title={(iia?.iia_status === "approved-by-all") ? "Modify IIA" : "Edit IIA"}
                        //   onClick={(e) => {
                        //     navigate("/iias/edit/" + iia?.id);
                        //   }}
                        onClick={() => navigate("/edit-evaluation", {
                            state: {
                              row: row,
                            }}) }
                        />
                        
                        <IconButton
                        variant="delete"
                        title="Delete Evaluation"
                        //   disabled={(iia?.approved_copy) || iia?.iia_status === "approved-by-all"}
                          onClick={() => {
                            setShowModalDelete(true); setSubmissionIdToDelete(row?.evaluation?.submission_id); setEvaluationIdToDelete(row?.evaluation?.evaluation_id);}}   
                        />
                    </div>

                </TableCell>
                </TableRow> 
            )
                
            )}
            
            </TableBody>
        </Table>
    </TableContainer>
    </div></div></>)}
    {(size === "xs" || size === "sm" || size === "md") && ( <>
    <div className="first-step-main-container rounded-3 mx-auto d-flex flex-column align-items-center position-relative" style={{width: "90%"}}>
    <div className="title mb-4">
    <h1 className="register-text" style={{fontSize: 40, marginBottom: 25, marginTop: 40}}>My evaluations</h1>
    <div style={{marginBottom: 40, fontSize: 16, textAlign: "left", marginTop: 10, lineHeight: "30px"}}>Here you can find the list of courses of the Online Learning Agreement you took in exchange.
            Provide feedback by  clicking on<br/> the ‘Create new evaluation’ button in the last column. You can also edit or delete previously submitted evaluations, by clicking<br/> on the ‘Edit’ icon <IconButton style={{marginLeft: 5}}
                        variant="edit"/> or ‘Delete’ icon<IconButton style={{marginLeft: 5}}
                        variant="delete"/>.

If you are academic staff of an HEI or future  exchange student looking for more <br/>info about the courses, please visit <a href={window.location.origin + "/all-evaluations"} style={{color: "burlywood"}}>‘All Evaluations’</a>.

            </div>
        {evaluationsListOLA?.map((row, index) => {
                  return (
                    <CustomTableRow
                      key={"row-id-" + (row.id || index)}
                      row={row}
                      labels={evaluationsListOLA?.length ? ["course_title", "course_code", "academic_term", "ects"] : []}
                      fieldToHeader={replaceUnderscoreAndCamelCaseToString}
                    //   columnsPerFieldMap={columnsPerFieldMap}
                    //   rowClassName={rowClassName}
                    //   className={`${
                    //     onClickHandlers.length > index
                    //       ? "table-row-with-on-click-handler"
                    //       : ""
                    //   }`}
                    //   onClickHandler={
                    //     onClickHandlers.length > index
                    //       ? onClickHandlers[index]
                    //       : undefined
                    //   }
                    //   onMouseDown={
                    //     onMouseDownHandlers?.length > index
                    //       ? onMouseDownHandlers[index]
                    //       : undefined
                    //   }
                    >
                      {/* {evaluationsListOLA?.map((row, index) => ( */}
                        <div
                            key={index}
                            className={`py-3 px-2 justify-content-end justify-content-lg-around align-items-center bg-none bg-md-light button-triplet-requests flex-grow-1 d-flex gap-3 gap-lg-1`}
                        >
                            <IconButton
                                variant="add"
                                onClick={() => navigate("/new-evaluation", {
                                    state: {
                                      rowOLA: row,
                                    }}) }
                                //   disabled={(iia?.terminated && iia?.iia_status !== "approved-by-all")}
                                //   title={(iia?.iia_status === "approved-by-all") ? "Modify IIA" : "Edit IIA"}
                                //   onClick={(e) => {
                                //     navigate("/iias/edit/" + iia?.id);
                                //   }}
                                /><span style={{textAlign: "left"}}>Create new evaluation</span>

                                {/* <IconButton
                                variant="delete"
                                title="Delete IIA"
                                //   disabled={(iia?.approved_copy) || iia?.iia_status === "approved-by-all"}
                                //   onClick={() => {
                                //     setShowModalDelete(true); setIdToDelete(iia?.id);}}   
                                /> */}
                        </div>
                    </CustomTableRow>
                  );
                })}
                {evaluationsList?.map((row, index) => {
                  return (
                    <CustomTableRow
                      key={"row-id-" + (row.id || index)}
                      row={row?.course}
                      labels={evaluationsListOLA?.length ? ["course_title", "course_code", "academic_term", "ects"] : []}
                      fieldToHeader={replaceUnderscoreAndCamelCaseToString}
                    //   columnsPerFieldMap={columnsPerFieldMap}
                    //   rowClassName={rowClassName}
                    //   className={`${
                    //     onClickHandlers.length > index
                    //       ? "table-row-with-on-click-handler"
                    //       : ""
                    //   }`}
                    //   onClickHandler={
                    //     onClickHandlers.length > index
                    //       ? onClickHandlers[index]
                    //       : undefined
                    //   }
                    //   onMouseDown={
                    //     onMouseDownHandlers?.length > index
                    //       ? onMouseDownHandlers[index]
                    //       : undefined
                    //   }
                    >
                      {/* {evaluationsListOLA?.map((row, index) => ( */}
                        <div
                            key={index}
                            className={`py-3 px-2 justify-content-end justify-content-lg-around align-items-center bg-none bg-md-light button-triplet-requests flex-grow-1 d-flex gap-3 gap-lg-1`}
                        >
                             <IconButton
                                variant="edit"
                                //   disabled={(iia?.terminated && iia?.iia_status !== "approved-by-all")}
                                //   title={(iia?.iia_status === "approved-by-all") ? "Modify IIA" : "Edit IIA"}
                                //   onClick={(e) => {
                                //     navigate("/iias/edit/" + iia?.id);
                                //   }}
                                onClick={() => navigate("/edit-evaluation", {
                                    state: {
                                    row: row,
                                    }}) }
                            />
                                
                            <IconButton
                                variant="delete"
                                title="Delete Evaluation"
                                //   disabled={(iia?.approved_copy) || iia?.iia_status === "approved-by-all"}
                                  onClick={() => {
                                    setShowModalDelete(true); setSubmissionIdToDelete(row?.evaluation?.submission_id); setEvaluationIdToDelete(row?.evaluation?.evaluation_id);}}   
                            />
                        </div>
                    </CustomTableRow>
                  );
                })}
    </div></div>
    </>)}
    <Modal
        show={showModalDelete}
        onHide={() => setShowModalDelete(false)}
        centered
        // fullscreen={fullscreen && "lg-down"}
        size={size}
      >
        <Modal.Header closeButton style={{ borderStyle: "none" }}>
          <Modal.Title>
            <div className="h2-style"><div className="body">{<div>You are about to <span style={{color: "red"}}>delete</span> an Evaluation</div>}</div></div>
            {/* <div className="h6-style">{subtitle}</div> */}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {"After deleting an Evaluation, you will not be able to see it again."}
        </Modal.Body>

        <Modal.Footer style={{ borderStyle: "none" }}>
          {/* <CustomButton
            buttonType={"secondary"}
            disabled={disabledCancelButton}
            text={"Cancel"}
            icon={hasIcon && faXmark}
            hasIcon={hasIcon}
            iconColor={hasIcon && COLORS.black}
            handleClick={handleClose}
          />
          {button} */}
                 <Button style={{background: "#E9E9E9", border: "1px solid #E9E9E9", borderColor: "#E9E9E9", color: "rgba(0, 0, 0, 0.87)"}} onClick={() => setShowModalDelete(false)}>Cancel</Button>
                 <Button  style={{background: "black", border: "1px solid black", borderColor: "black"}} onClick={handleDelete}>Delete</Button>

        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MyEvaluations;
